import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeHelper } from '../../../util/date-time-helper';

@Pipe({
  name: 'timeBlockAccumulatedWork',
  standalone: false,
})
export class TimeBlockAccumulatedWorkPipe implements PipeTransform {
  transform(accumulatedTimeSumMap: Map<string, number>, dayOrWeekIndex?: Date | number): string {
    if (dayOrWeekIndex) {
      return dayOrWeekIndex instanceof Date
        ? this.calculateTimeSumForDate(accumulatedTimeSumMap, dayOrWeekIndex)
        : this.calculateTimeSumForWeek(accumulatedTimeSumMap, dayOrWeekIndex);
    }
    return this.calculateTotalTimeSum(accumulatedTimeSumMap);
  }

  /*
  Time sum for each day in week view.
   */
  private calculateTimeSumForDate(accumulatedTimeSumMap: Map<string, number>, date: Date): string {
    const key = DateTimeHelper.format(date);
    if (accumulatedTimeSumMap.has(key)) {
      const sumSeconds = accumulatedTimeSumMap.get(key);
      return DateTimeHelper.formatSecondsToHoursAndMinutes(sumSeconds);
    }
    return '00:00';
  }

  /*
  Time sum for each week in month view.
   */
  private calculateTimeSumForWeek(accumulatedTimeSumMap: Map<string, number>, weekNumber: number) {
    const key = weekNumber.toString();
    if (accumulatedTimeSumMap.has(key)) {
      const sumSeconds = accumulatedTimeSumMap.get(key);
      return DateTimeHelper.formatSecondsToHoursAndMinutes(sumSeconds);
    }
    return '00:00';
  }

  /*
  Calculate total time in the control bar.
   */
  private calculateTotalTimeSum(accumulatedTimeSumMap: Map<string, number>): string {
    let sumSeconds = 0;
    accumulatedTimeSumMap.forEach((secondsWorkedPerDay) => (sumSeconds += secondsWorkedPerDay));
    return DateTimeHelper.formatSecondsToHoursAndMinutes(sumSeconds);
  }
}
